import { sortDate } from '../../utils/sort/sortDate';
import { sortNumber } from '../../utils/sort/sortNumber';
import { sortNumberOrString } from '../../utils/sort/sortNumberOrString';
import { sortNumberWithPrefix } from '../../utils/sort/sortNumberWithPrefix';
import { sortString } from '../../utils/sort/sortString';
import { OrderType } from '../schemas';
import { DataUnitDataListTransitionResponse } from './types';

let sortRows: DataUnitDataListTransitionResponse['data']['rows'];

export const sortUnitDataListTransition = (
  dataUnitDataListTransition: DataUnitDataListTransitionResponse,
  order: OrderType,
  sort: string
): DataUnitDataListTransitionResponse => {
  if (!dataUnitDataListTransition) {
    return dataUnitDataListTransition;
  }

  // sortの文字列とdata?.data.columnsのcodeが一致するindexを取得
  const sortIndex = dataUnitDataListTransition?.data.columns.findIndex(
    (column) => column.code === sort
  );

  // sortの文字列とdata?.data.columnsのcodeが一致するtypeを取得
  const sortType =
    sort === 'date'
      ? { name: '曜日', code: 'date', type: 'date' }
      : dataUnitDataListTransition?.data.columns.find(
          (column) => column.code === sort
        );

  if (sortIndex == null || sortType == null) {
    return dataUnitDataListTransition;
  }

  switch (sortType.type) {
    case 'string':
      sortRows = sortString(
        dataUnitDataListTransition.data.rows,
        sortIndex,
        order,
        'unitDataListTransition'
      );
      break;
    case 'number':
      sortRows = sortNumber(
        dataUnitDataListTransition.data.rows,
        sortIndex,
        order,
        'unitDataListTransition'
      );
      break;
    case 'numberWithPrefix':
      sortRows = sortNumberWithPrefix(
        dataUnitDataListTransition.data.rows,
        sortIndex,
        order,
        'unitDataListTransition'
      );
      break;
    case 'numberOrString':
      sortRows = sortNumberOrString(
        dataUnitDataListTransition.data.rows,
        sortIndex,
        order,
        'unitDataListTransition'
      );
      break;
    case 'date':
      sortRows = sortDate(
        dataUnitDataListTransition.data.rows,
        order,
        dataUnitDataListTransition.setting.startDate,
        dataUnitDataListTransition.setting.endDate
      );
      break;
    default:
      return dataUnitDataListTransition;
  }

  return {
    ...dataUnitDataListTransition,
    // rowsをsortedRowsに変更
    data: {
      ...dataUnitDataListTransition.data,
      rows: sortRows,
    },
  };
};
